export default __webpack_public_path__ + "static/assets/med_pill_triangle_flat_L1_solid_x_01_f.e3197928.png";